import React from "react";
import ModuleHeader from "../components/ModuleHeader/ModuleHeader";
import usePrivateLink from "../config/usePrivateLink";

export default function AcademicPortalLayout({ children }) {
  return ;
  const hasAccess = usePrivateLink();

  const tabs = [
    {
      id: "batches",
      title: "Batches",
      description: "Manage student batches",
      icon: "ri-graduation-cap-line",
      activePaths: [
        "/batches",
        "/batch/add",
        "/batch/update",
        "/batch/detail",
      ],
    },
    {
      id: "courses",
      title: "Courses",
      description: "Academic courses",
      icon: "ri-book-open-line",
      activePaths: ["/courses", "/course/add", "/course/update"],
    },
    {
      id: "subjects",
      title: "Subjects",
      description: "Course subjects",
      icon: "ri-book-3-line",
      activePaths: ["/subjects"],
    },
    {
      id: "sessions",
      title: "Sessions",
      description: "Academic sessions",
      icon: "ri-calendar-2-line",
      activePaths: ["/sessions"],
    },
    {
      id: "discount-offers",
      title: "Discount Offers",
      description: "Offers and discounts",
      icon: "ri-percent-line",
      activePaths: [
        "/discount/offers/list",
        "/discount/offers/add",
        "/discount/offers/update",
      ],
    },
  ];

  const permittedTabs = tabs
    .map((tab) => {
      const accessiblePaths = tab.activePaths.filter((route) =>
        hasAccess(route)
      );

      return {
        ...tab,
        path: accessiblePaths[0] || "/",
        access: accessiblePaths.length > 0,
      };
    })
    .filter((tab) => tab.access);

  return (
    <>
      <ModuleHeader tabs={permittedTabs} />
      {children}
    </>
  );
}